module.exports = __webpack_public_path__ + "img/estimates3.b3add711.svg";